import React from 'react';
import { LineReduccion } from '../components/LineReduccion';
import { MedirReduccion } from '../components/MedirReduccion';

function Reduccion( props ) {
  console.log(props.user.email)
  const [metaChecked, setMetaChecked] = React.useState([])
  const metasReduccion = ["Reducir porcentaje en Transporte terrestre trabajo 10%",
                          "Reducir porcentaje en Consumo de energía un 5%",
                          "Reducir porcentaje en Transporte Terrestre materias primas un 8%",
                          "Reducir porcentaje en Transporte Aéreo 9%",
                          "Reducir porcentaje en Transporte marítimo 8%"]
  
  return (
    <div id='cards' className='cards'>
      <h1 style={{ position:'relative', top:'20px', color:'#115BFF'}}><span style={{ background:'#0B149D',color:'white',fontWeight:'bold'}}>Reducción</span> de tu huella en el tiempo (Kg CO<sub>2</sub>eq.)</h1>
      
      <div className='cards__container'>
        <div className='cards__wrapper' style={{width:'100%'}}>

          <ul className='cards__items'>
            <div style={{ width:'100%'}}>
              <div>
              <LineReduccion></LineReduccion>
              </div>
            </div>
          </ul>

          <ul className='cards__items'>
            
            <li className='cards__item' style={{boxShadow:' 0 6px 20px rgb(56 125 255 / 17%)',
              filter:' drop-shadow(0 6px 20px rgba(56, 125, 255, 0.017))'}}>
              <div style={{display:'block'}}>
                <div style={{textAlign:'Center', padding:'10px'}}>
                  <img src='/icon-goals.svg'></img>
                  <span style={{color:'#0B149D', fontSize:'larger'}}>Escenarios de reducción actuales</span>
                </div>
                
                <div className='checkList'>
                  <div className='list-container'>
                    { metasReduccion.map((meta, index) => (
                        <div style={{width:'75%'}} key={index}>
                          <input value={meta} type="checkbox" />
                          <span>{meta}</span>
                        </div>
                      ))
                    }
                  </div>
                </div>
              </div>
 
            </li>
            <li className='cards__item' style={{boxShadow:' 0 6px 20px rgb(56 125 255 / 17%)',
              filter:' drop-shadow(0 6px 20px rgba(56, 125, 255, 0.017))'}}>
              <div className='cards__item__link'>
                <div style={{textAlign:'Center'}}>
                  <img src='/icon-add-goals.svg'></img>
                  <span style={{color:'#0B149D', fontSize:'18px'}}>Añadir entrada de reducción nueva</span>
                </div>
                <MedirReduccion user={props.user}></MedirReduccion>
              </div>
            </li>
          </ul>

        </div>
      </div>
    </div>
  )
}

export { Reduccion }
